import axios from 'axios'
import KeycloakService from '../utils/keycloakService'
import { HOMEKARE_GET, HOMEKARE_PATCH } from '../utils/Endpoints'

export const getHomeKareAppointments = async (
  page: number,
  size: number,
  searchTerm?: string,
  status?: string
) => {
  const token = KeycloakService.getToken()
  const queryParams = new URLSearchParams()

  if (searchTerm) queryParams.append('searchTerm', searchTerm)
  if (status) queryParams.append('status', status)
  queryParams.append('page', page.toString())
  queryParams.append('size', size.toString())

  try {
    const response: any = await axios.get(
      `${
        process.env.REACT_APP_API_GATEWAY_URL
      }${HOMEKARE_GET}${queryParams.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    console.error('Error fetching Homekare: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}

export const updateHomeKareAppointment = async (payload: any, id: string) => {
  const token = KeycloakService.getToken()
  try {
    const response: any = await axios.patch(
      `${process.env.REACT_APP_API_GATEWAY_URL}${HOMEKARE_PATCH}${id}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    console.error('Error Patching Homekare: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}
